import { TUtmSource } from '~/constants/utm-sources';
import { PARTNERS_CONFIG } from '~/apps/main/Partners/partners-config';
import {
    TPartner,
    TPartnerWelcomeModalTriggerPage,
    TPartnerComputedInfo
} from '~/apps/main/Partners/partners.types';

export const getPartnerFromUtmSource = (
    utmSource?: string
): TPartner | undefined => {
    if (!utmSource) {
        return;
    }
    const partner = Object.entries(PARTNERS_CONFIG).find(
        ([, data]) => data.utmSource === utmSource
    );
    return partner?.[0] as TPartner | undefined;
};

export const getWelcomeModalsToOpenFromOrigin = (
    triggerPage: TPartnerWelcomeModalTriggerPage
) => {
    const partners = Object.entries(PARTNERS_CONFIG).filter(
        ([, data]) =>
            data.welcomeModal?.triggerPage === triggerPage &&
            !data.utmSource.includes('expired')
    );
    return partners.map(([partner]) => partner as TPartner);
};

export const getPartnerSignupLayoutFromUtmSource = (utmSource: TUtmSource) => {
    const partner = getPartnerFromUtmSource(utmSource);
    return partner && 'signup' in PARTNERS_CONFIG[partner]
        ? PARTNERS_CONFIG[partner].signup?.layout
        : undefined;
};

export const getPartnerSignupTransKey = ({
    utmSource,
    isMobile
}: {
    utmSource: string;
    isMobile: boolean;
}) => {
    const partner = getPartnerFromUtmSource(utmSource);
    if (!partner) {
        return;
    }
    const data = PARTNERS_CONFIG[partner];
    return isMobile ? data.signup?.transKeyMobile : data.signup?.transKey;
};

export const isPartnerRequiresIntegration = (
    partnerComputedInfo: TPartnerComputedInfo
) =>
    partnerComputedInfo.coupon?.requiresIntegration &&
    !partnerComputedInfo.isIntegrated;

export const isPartnerCouponEligible = (
    partnerComputedInfo: TPartnerComputedInfo
) => {
    return (
        partnerComputedInfo.coupon?.isEligible &&
        !isPartnerRequiresIntegration(partnerComputedInfo)
    );
};
